import { FormattedMessage } from 'react-intl';
import React from 'react';
import { UISref } from '@uirouter/react';

import { productFormattedLabel } from '@/utils/common';

const getLatestAnalysis = (record: cyrian.api.waybills.Waybill) => {
  const arr = record.weighingAnalyses;
  return arr?.length ? arr[0] : undefined;
};

export const getColumns = (lotId: number) => {
  return [
    {
      title: 'id',
      dataIndex: 'id',
      width: 80,
      sorter: (a: cyrian.api.waybills.Waybill, b: cyrian.api.waybills.Waybill) => a.id - b.id,
    },
    {
      title: <FormattedMessage id="waybills.waybillNumber" />,
      dataIndex: 'waybillNumber',
      sorter: (a: cyrian.api.waybills.Waybill, b: cyrian.api.waybills.Waybill) =>
        (a.waybillNumber || '').localeCompare(b.waybillNumber || ''),
      render: (_: unknown, record: cyrian.api.waybills.Waybill) => (
        <UISref to="base-layout.waybills.view" params={{ waybillId: record.id }}>
          <button type="button" className="ant-btn ant-btn-link ant-btn-sm p-0">
            {record.waybillNumber}
          </button>
        </UISref>
      ),
    },
    {
      title: <FormattedMessage id="waybills.product" />,
      dataIndex: ['product', 'name'],
      sorter: (a: cyrian.api.waybills.Waybill, b: cyrian.api.waybills.Waybill) =>
        (a.product?.name || '').localeCompare(b.product?.name || ''),
      render: (_: unknown, record: cyrian.api.waybills.Waybill) => productFormattedLabel(record.product),
    },
    {
      title: <FormattedMessage id="waybills.campaign" />,
      dataIndex: ['campaign', 'name'],
      sorter: (a: cyrian.api.waybills.Waybill, b: cyrian.api.waybills.Waybill) =>
        (a.campaign?.name || '').localeCompare(b.campaign?.name || ''),
    },
    {
      title: <FormattedMessage id="waybills.status" />,
      dataIndex: 'status',
      sorter: (a: cyrian.api.waybills.Waybill, b: cyrian.api.waybills.Waybill) =>
        (a.status || '').localeCompare(b.status || ''),
    },
    {
      title: <FormattedMessage id="waybills.latestSupplierName" />,
      render: (_: unknown, record: cyrian.api.waybills.Waybill) =>
        record.cooperative?.name ?? getLatestAnalysis(record)?.cooperative?.name ?? '-',
    },
    {
      title: <FormattedMessage id="lots.waybills.relatedLots" />,
      key: 'relatedLots',
      render: (_: unknown, record: cyrian.api.waybills.Waybill) => {
        const details = record.lotDetails || [];
        if (!details.length) return '-';
        return (
          <>
            {details.map((d, i) =>
              d.lot?.number ? (
                <React.Fragment key={d.id ?? i}>
                  {i > 0 ? ', ' : null}
                  <UISref to="base-layout.lots.view" params={{ lotId: d.lot.id }}>
                    <button type="button" className="ant-btn ant-btn-link ant-btn-sm p-0">
                      {d.lot.number}
                    </button>
                  </UISref>
                </React.Fragment>
              ) : (
                '-'
              ),
            )}
          </>
        );
      },
    },
  ];
};
